import styled from '@emotion/styled';

export const MetabolismWrapper = styled.div``;
